<template>
  <p>Nothing to see. :(</p>
</template>

<script>
export default {
  name: 'App'
}
</script>